export const compose = (...fns) =>
    result => {
        var list = [...fns];

        while (!!list.length) {
            result = list.pop()(result);
        }

        return result;
    };

export default {
    compose: compose
}


// WEBPACK FOOTER //
// ./src/utils/fp.js